const DEV_PORTAL_TOKEN_KEY = 'cc.portal.dev.access-token';
const DEV_PORTAL_HASH_KEY = 'portal_access_token';

const validToken = (value) => {
  return typeof value === 'string'
    && value.length >= 20
    && value.length <= 8192
    && /^[A-Za-z0-9._-]+$/.test(value);
};

const isLocalPortalUrl = (url) => {
  try {
    const hostname = new URL(url).hostname.toLowerCase();
    return hostname === 'localhost' || hostname.endsWith('.localhost');
  } catch {
    return false;
  }
};

// The fragment is never sent in the HTTP request or Referer header. The tenant
// consumes and removes it on its first render, bridging only the local
// localhost -> school.localhost origin boundary.
export const withDevPortalAccessToken = (url, token) => {
  if (!isLocalPortalUrl(url) || !validToken(token)) { return url; }
  const destination = new URL(url);
  destination.hash = new URLSearchParams({ [DEV_PORTAL_HASH_KEY]: token }).toString();
  return destination.toString();
};

export const consumeDevPortalAccessToken = ({
  location = globalThis.location,
  history = globalThis.history,
  storage = globalThis.sessionStorage,
} = {}) => {
  try {
    const params = new URLSearchParams(String(location?.hash || '').replace(/^#/, ''));
    const token = params.get(DEV_PORTAL_HASH_KEY);
    if (!validToken(token)) { return false; }
    storage.setItem(DEV_PORTAL_TOKEN_KEY, token);
    history.replaceState(history.state, '', `${location.pathname || '/'}${location.search || ''}`);
    return true;
  } catch {
    return false;
  }
};

export const getDevPortalAccessToken = (storage = globalThis.sessionStorage) => {
  try {
    const token = storage.getItem(DEV_PORTAL_TOKEN_KEY);
    return validToken(token) ? token : null;
  } catch {
    return null;
  }
};

export const clearDevPortalAccessToken = (storage = globalThis.sessionStorage) => {
  try {
    storage.removeItem(DEV_PORTAL_TOKEN_KEY);
  } catch {
    // Storage can be unavailable in hardened browser contexts. The API signout
    // still clears the server-side portal session in that case.
  }
};
